/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import UserPreferences from '@ion/core/src/preferences/UserPreferences';
import {UserContext} from '@ion/core/src/services/MicroServices';
import {User} from '@ion/core/src/types/entities';
import {UserEditor} from '@ion/dls/src/editors/UserEditor';
import {ApplicationKeys} from '../../../types/application';
import {addAdminUser, addUser} from './state';
import {useAuthenticatedUser} from './useAuthenticatedUser';

// defines the add user props ...
export type AddUserProps = {
  getRouteLabel: (route: string, useTitleCase: boolean) => string;
  defaultPageId: string;
  isViewDialog: boolean;
  isCtcAdmin?: boolean;
  context?: UserContext;
  includeApplications?: boolean;
  includeAddresses?: boolean;
  includeContacts?: boolean;
  multipleAddress?: boolean;
  enableAutoSave?: boolean;
}
/**
 * @AddUserEditor
 */
export const AddUserEditor = ({
  isViewDialog,
  isCtcAdmin,
  context,
  includeApplications,
  includeAddresses,
  includeContacts,
  enableAutoSave = false,
  multipleAddress = false
}: AddUserProps) => {
  const dispatch                = useDispatch();
  const {globalGroup}           = useSelector(({globalGroup}) => globalGroup);
  const {loading}               = useSelector(({adminUsers: {add}}) => add);
  const currentUser             = useAuthenticatedUser();
  const {accounts: subAccounts} = useSelector(({initialization}) => initialization);

  const onSave = useCallback((user: User) => {
    user.notify = isCtcAdmin;
    dispatch(addUser(user, context));
  }, [context, isCtcAdmin]);

  return (
    <UserEditor open
      isCtcAdmin={isCtcAdmin}
      context={context}
      multipleAddress={multipleAddress}
      includeApplications={includeApplications}
      includeAddresses={includeAddresses}
      includeContacts={includeContacts}
      isViewDialog={isViewDialog}
      isCurrentUser={false}
      enableAutoSave={enableAutoSave}
      api={enableAutoSave ? UserPreferences : undefined}
      account={globalGroup || currentUser?.account}
      subAccounts={subAccounts}
      loading={loading}
      namespace={ApplicationKeys.CTCAdmin}
      onSave={onSave}
      onCancel={function() {
        dispatch(addAdminUser(false));
      }} />
  );
};

export default AddUserEditor;
